/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Trust_CheckedInputs */

const en_directory_home_trust_checked = /** @type {(inputs: Directory_Home_Trust_CheckedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing & signup checked`)
};

const zh_directory_home_trust_checked = /** @type {(inputs: Directory_Home_Trust_CheckedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标注定价与登录要求`)
};

/**
* | output |
* | --- |
* | "Pricing & signup checked" |
*
* @param {Directory_Home_Trust_CheckedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_trust_checked = /** @type {((inputs?: Directory_Home_Trust_CheckedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Trust_CheckedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_trust_checked(inputs)
	return zh_directory_home_trust_checked(inputs)
});
export { directory_home_trust_checked as "directory.home.trust_checked" }